import { Suspense } from 'react';

import UserProfileHeader from 'components/UserProfileHeader/UserProfileHeader';

import useResponsiveSize from 'shared/hooks/useResponsiveSize';

import Loader from '../Loader/Loader';

type ThreeColumnLayoutProps = {
	children?: any;
};

const ThreeColumnLayout = ({ children }: ThreeColumnLayoutProps) => {
	const { isSmallDesktopScreen } = useResponsiveSize();

	return (
		<>
			{!isSmallDesktopScreen && <UserProfileHeader />}
			<Suspense fallback={<Loader />}>{children}</Suspense>
		</>
	);
};

export default ThreeColumnLayout;
